module.exports = __webpack_public_path__ + "static/media/O2.fcdff8e4.png";